import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const sel = "h-10 w-full rounded-md border border-border bg-transparent px-2 text-sm";
export const reserveMove = (kind, e, woId) => api.post("/inventory/movements", { item_id: e.item_id, kind, quantity: 1, location_id: e.location_id, serials: [e.serial], work_order_id: woId, reason: "Equipo GPS seleccionado en la OS" });

export const InventoryDevicePick = ({ woId, technicianId, d, onPick, testid }) => {
  const { can } = useAuth();
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);
  const model = d.model || d.planned_model;
  const load = () => api.get("/inventory/gps-available", { params: { model, model_id: d.model_refs?.[model] || undefined, work_order_id: woId || undefined, technician_id: technicianId || undefined } }).then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { if (model) load(); }, [model, woId, technicianId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!model || !can("inventory.write")) return null;

  const pick = async (serial) => {
    const e = rows.find((r) => r.serial === serial);
    if (!e || e.serial === d.imei) return;
    const picked = { ...d, model, imei: e.serial, ...(e.sim_iccid ? { sim_iccid: e.sim_iccid } : {}) };
    if (!woId) {
      onPick({ ...picked, inv_pick: e.held_by_tech ? null : { item_id: e.item_id, location_id: e.location_id, serial: e.serial } });
      return toast.success(e.held_by_tech ? `IMEI ${e.serial} (lo trae el técnico) seleccionado.` : `IMEI ${e.serial} seleccionado. Se reservará al crear la OS.`);
    }
    setBusy(true);
    try {
      if (!e.reserved_here && !e.held_by_tech) await reserveMove("reserva", e, woId);
      const prev = rows.find((r) => r.serial === d.imei && r.reserved_here);
      if (prev) await reserveMove("liberacion", prev, woId).catch(() => {});
      onPick(picked);
      toast.success(e.held_by_tech ? `IMEI ${e.serial} (lo trae el técnico) seleccionado. Guarda la unidad para conservarlo.` : `IMEI ${e.serial} reservado para esta OS. Guarda la unidad para conservarlo.`);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      load();
    }
  };

  const label = (r) => `${r.brand} ${r.model} · IMEI ${r.serial}${r.sim_iccid ? ` · SIM ${r.sim_iccid}` : ""} · ${r.held_by_tech ? "lo trae el técnico" : r.location_path}${r.reserved_here ? " · reservado para esta OS" : ""}`;
  return (
    <div className="col-span-2 space-y-1">
      <Label className="text-[11px] text-muted-foreground">Equipo de inventario ({model})</Label>
      {rows && !rows.length ? <p className="text-xs text-amber-400" data-testid={`${testid}-empty`}>No hay equipos {model} disponibles en inventario. Captura el IMEI manualmente o registra la entrada del equipo en Inventario.</p>
        : <select className={sel} value={rows?.some((r) => r.serial === d.imei) ? d.imei : ""} disabled={busy || !rows} onChange={(e) => pick(e.target.value)} data-testid={testid}>
          <option value="">{rows ? "Seleccionar equipo disponible" : "Cargando…"}</option>
          {(rows || []).map((r) => <option key={r.serial} value={r.serial}>{label(r)}</option>)}
        </select>}
    </div>
  );
};
